var map = {
	"./active-btn.webp": 2516,
	"./angbao-bonus-thaipusam.webp": 2517,
	"./angbao-bonus.webp": 2518,
	"./angbao-bonus_dewali.webp": 2519,
	"./cny-lucky-draw.webp": 2520,
	"./cny-promo.webp": 2521,
	"./dewali-promo.webp": 2522,
	"./fifa-prediction.webp": 2523,
	"./fifa-qna.webp": 2524,
	"./raya-promo.webp": 2525,
	"./welcome-cny-bonus.webp": 2526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2515;